import { render, staticRenderFns } from "./studyDetail.vue?vue&type=template&id=4651b4b2&scoped=true&"
import script from "./studyDetail.vue?vue&type=script&lang=js&"
export * from "./studyDetail.vue?vue&type=script&lang=js&"
import style0 from "./studyDetail.vue?vue&type=style&index=0&id=4651b4b2&scoped=true&lang=scss&"
import style1 from "./studyDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651b4b2",
  null
  
)

export default component.exports